import HttpTransport from '@/bundles/Http/transport/HttpTransport';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';
import { IListRequestReturn } from '@/bundles/Http/interfaces/IListReturn';
import { generateParams } from '@/helpers/functions';

export default class SessionService {
  private readonly transport: HttpTransport;
  private readonly errorMapper: ErrorMapper;

  constructor(transport: HttpTransport, errorMapper: ErrorMapper) {
    this.transport = transport;
    this.errorMapper = errorMapper;
  }

  async list(params: any[]): Promise<any> {
    try {
      const paramsString = generateParams(params);
      return await this.transport.get(`/session${paramsString}`);
    } catch (error) {
      throw this.errorMapper.mapToModel(error);
    }
  }
}
